import './Counters.scss';
import clsx from 'clsx';

import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { CounterList } from '@/src/components/common/Counters/Config';
import { RootState } from '@/src/reducers/types';

import Counter from '../../../Common/Counters/Counter/Counter';
import { useCounters } from '../../api/getCounters';
import SectionLoader from '@/src/components/common/Elements/Spinner/SectionLoader/SectionLoader';

type CountersProps = {
  projectId: string;
};

const LAYOUT = 'default';

const Counters = ({ projectId }: CountersProps) => {
  const loggedUser = useSelector((store: RootState) => store.loggedUser);
  const socket = useSelector((store: RootState) => store.socket.container);

  const countersQuery = useCounters({
    projectId,
    userRole: loggedUser.data.userRole,
    userId: loggedUser.data.id,
    date: moment().format('YYYY-MM-DD'),
  });
  const [counters, setCounters] = useState([]);

  useEffect(() => {
    socket.on('FRONT_COUNTER', () => {
      countersQuery.refetch();
    });
  }, []);

  useEffect(() => {
    if (!countersQuery.data) {
      return;
    }

    setCounters([
      { ...CounterList.files, ...countersQuery.data.new_files },
      { ...CounterList.today, ...countersQuery.data.task_due },
      { ...CounterList.forReview, ...countersQuery.data.task_for_review },
      { ...CounterList.forApproval, ...countersQuery.data.task_for_approval },
      { ...CounterList.delayed, ...countersQuery.data.delayed_task },
    ]);
  }, [countersQuery.data]);

  if (countersQuery.isLoading) {
    return (
      <SectionLoader
        className={clsx('container--reports', 'tw-h-[calc(100%-5px)] tw-w-full tw-mr-[20px]')}
      />
    );
  }

  if (!countersQuery.data) {
    return null;
  }

  return (
    <div className="countersContainer">
      {counters.map((status, index) => {
        return (
          <Counter
            key={`dashboardCounters_${index}`}
            layout={LAYOUT}
            projectId={projectId}
            {...status}
          />
        );
      })}
    </div>
  );
};

export default Counters;
